import React from 'react';
import { Carousel } from '@vds/carousels';
import { TextLinkCaret } from '@vds/buttons';
import {
  Block,
  Flex,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from '../../../components/common/StyledComponent/CommonStyledComponent';
import AIRecommendedCard from './AIRecommendedCard';
import styled from 'styled-components';

const CarouselWrapper = styled.div`

filter: drop-shadow(0px 16px 24px rgba(0, 0, 0, 0.049));

  // @media (min-width: 1024px) {
  //   div[class^=SlotContainer-VDS] {
  //     flex: 0 0 337.5px;
  //   }
  // }

  // @media (min-width: 767px) and (max-width: 1023px) {
  //   div[class^=SlotContainer-VDS] {
  //     flex: 0 0 344px;
  //   }
  // }
`;

const AITopRecommendationCarouselSection = () => {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const isTablet =
    window.innerWidth > MOBILE_BREAKPOINT &&
    window.innerWidth <= TABLET_BREAKPOINT;

  return (
    <Block marginTop="32px">
      <Flex padding={isMobile ? '0 16px' : '0 24px'} flexDirection={isMobile ? 'column' : 'row'} alignItems='flex-start' gap={isMobile ? '16px': "24px" }justifyContent="space-between">
        <Flex flexDirection='column' gap='8px'>
            <div className="vds-title-sm mobile-vds-title-xs font-eDS-bold">
            Top recommendations
            </div>
            <div className="vds-body-lg">
                These courses will help you build a strong foundation in digital marketing and learn how to attract and engage customers online. 
            </div>
        </Flex>
        <Flex width="fit-content" flexWrap="nowrap">
            <TextLinkCaret
            surface="light"
            disabled={false}
            iconPosition="right"
            onClick={(e) => alert('TextLinkCaret clicked')}
            >
          <span style={{ whiteSpace: 'nowrap' }}>View all recommendations</span>
            </TextLinkCaret>
        </Flex>
      </Flex>
      <CarouselWrapper className="mt-6X pb-8X sm-pb-4X">
        <Carousel
          layout={isMobile ? '1UP' : isTablet ? '2UP' : '3UP'}
          gutter={isMobile ? '12px' : '24px'}
          peek={isMobile || isTablet ? 'standard' : 'none'}
          surface="light"
          paginationInset="12px"
          pagination={{
            kind: 'lowContrast',
            hideBorder: true,
            floating: true,
          }}
          paginationDisplay="persistent"
          aspectRatio="none"
          data={[
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Up to 30% off gifts perfect for anyone',
              },
              descriptiveIcon: {
                size: 'medium',
              },
              backgroundColor: 'black',
              showBorder: true,
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'iPhone 13, On us.',
              },
              subtitle: {
                size: 'bodyLarge',
                primitive: 'h1',
                children:
                  'Big upgrades. Incredible new possibilities. Save on the latest iPhone.',
              },
              backgroundColor: 'white',
              showBorder: true,
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get 5G Home Internet starting at $25/mo.',
              },
              backgroundColor: 'white',
              backgroundImage:
                'https://ss7.vzw.com/is/image/VerizonWireless/vz-homepage-m-ourlatest-2?scl=1',
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get Unlimited starting at $35/mo.',
              },
              backgroundColor: 'white',
              showBorder: true,
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get 35% off accessories when you buy 4 or more',
              },
              backgroundColor: 'black',
              showBorder: true,
              descriptiveIcon: {
                size: 'medium',
              },
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: '5G Ultra Wideband. Now in more and more places.',
              },
              backgroundColor: 'gray',
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Up to 30% off gifts',
              },
              backgroundColor: 'white',
              backgroundImage:
                'https://ss7.vzw.com/is/image/VerizonWireless/vz-homepage-d-june1-Tile22?&?scl=1',
              showBorder: true,
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get 5G Home Internet starting at $25/mo.',
              },
              backgroundColor: 'black',
              backgroundImage:
                'https://ss7.vzw.com/is/image/VerizonWireless/vz-homepage-m-ourlatest-2?scl=1',
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get Unlimited starting at $35/mo.',
              },
              backgroundColor: 'white',
              showBorder: true,
              onClick: () => {},
            },
            {
              title: {
                size: 'titleLarge',
                primitive: 'h1',
                children: 'Get 35% off accessories when you buy 4 or more',
              },
              backgroundColor: 'gray',
              onClick: () => {},
            },
          ]}
          renderItem={(props) => <AIRecommendedCard {...props} isMobile={isMobile} width="100%" />}
        />
      </CarouselWrapper>
    </Block>
  );
};

export default AITopRecommendationCarouselSection;
